import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"

export type Location = {
  lat?: string
  lon?: string
  bearing?: string
  country?: string
  countryCode?: string
  locality?: string
  street?: string
  postalCode?: string
  formattedAddress?: string
  companyName?: string
  odometer?: number
  fuelLevel?: number
  fuelLiters?: number
  temperatureMain?: number
  temperatureAdditional?: number
  stationarySince?: string
  speed?: number // km/h
  timestamp?: string // when the GPS took this position
}

export type DriverLocation = {
  jid: string
  location: Location | undefined
  receivedAt?: number
}

export type Locations = Record<string, DriverLocation>

const initialState: Locations = {}

type UpsertLocationAction = {
  driverLocation: DriverLocation
}
type BatchUpsertLocationAction = {
  driversLocations: DriverLocation[]
}

const locations = createSlice({
  name: "locations",
  initialState,
  reducers: {
    upsertLocation: (
      state: Locations,
      action: PayloadAction<UpsertLocationAction>,
    ) => {
      state[action.payload.driverLocation.jid] = {
        jid: action.payload.driverLocation.jid,
        location: action.payload.driverLocation.location,
        receivedAt: Date.now(),
      }
    },
    batchUpsertLocation: (
      state,
      action: PayloadAction<BatchUpsertLocationAction>,
    ) => {
      const now = Date.now()
      for (const driverLocation of action.payload.driversLocations) {
        state[driverLocation.jid] = {
          jid: driverLocation.jid,
          location: driverLocation.location,
          receivedAt: now,
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const { upsertLocation, batchUpsertLocation } = locations.actions

export default locations.reducer
